export const removeEmailFooter = (htmlString: string) => {
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = htmlString

  tempDiv.querySelectorAll('.sl-email-footer').forEach(element => element.remove())

  return tempDiv.innerHTML
}

export const addTemplateWrapper = (htmlString: string) => {
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = htmlString

  tempDiv.querySelectorAll('p').forEach(element => {
    element.style.marginTop = '1em'
    element.style.marginBottom = '1em'
  })

  return tempDiv.innerHTML
}
